// Lightweight localStorage-backed "recently viewed" tracker.
// Keeps the last N product cards (slim shape) so we can render
// a carousel on Home + the PDP without hitting the API.

const KEY = "luxsova:recently-viewed";
const MAX = 12;

const read = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch (e) {
    console.warn("[recentlyViewed] read failed:", e);
    return [];
  }
};

const write = (arr) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX)));
  } catch (e) {
    // quota / private mode — non-fatal
    console.warn("[recentlyViewed] write failed:", e);
  }
};

export const getRecentlyViewed = () => read();

export const pushRecentlyViewed = (product) => {
  if (!product?.slug) return;
  const slim = {
    id: product.id,
    slug: product.slug,
    name: product.name,
    image: product.image || product.images?.[0] || null,
    price: product.price,
    regular_price: product.regular_price,
    sale_price: product.sale_price,
    on_sale: product.on_sale,
    categories: product.categories?.slice(0, 1) || [],
  };
  const prev = read().filter((p) => p.slug !== slim.slug);
  prev.unshift(slim);
  write(prev);
};

/**
 * Returns up to `limit` most-visited categories across the recently
 * viewed list — used by the /collections filter chips to personalise
 * recommendations ("More sneakers", "More bags"). Categories are picked
 * from each product's first (primary) category, weighted by visit count.
 */
export const getTopCategoriesFromRecent = (limit = 3) => {
  const seen = new Map(); // slug → {slug, name, count}
  for (const p of read()) {
    const c = p.categories?.[0];
    if (!c?.slug) continue;
    const cur = seen.get(c.slug);
    if (cur) cur.count += 1;
    else seen.set(c.slug, { slug: c.slug, name: c.name || c.slug, count: 1 });
  }
  return [...seen.values()]
    .sort((a, b) => b.count - a.count)
    .slice(0, limit);
};
